// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24NUR","col":"styles_col__15T8i"};